import type { NextPage } from 'next'
import styles from '../../styles/form/textInput.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { joinClassnames } from 'helpers/classNames'
import { faLock, faEnvelope, faUser, faPlus, } from '@fortawesome/free-solid-svg-icons'
import { useEffect, useRef, useState } from 'react'
import { Size } from 'types/size'
import { Type } from 'types/type'

library.add(faLock, faEnvelope, faUser, faPlus)

interface Props {
  text: string
  placeholder?: string
  onChange: any
  icon?: any
  type?: string
  color?: string
  label?: string
  smallPadding?: boolean
  required?: boolean
  disabled?: boolean
  size?: Size
  maxLength?: number
  colorType?: Type
  border?: boolean
  shadow?: boolean
}
const TextInputComponent: NextPage<Props> = (props: Props) => {
  const [value, setValue] = useState(props.text);
  const MAX_POST_LENGTH = props.maxLength != null ? props.maxLength : 500;
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setValue(props.text)
  }, [props.text])

  const textInputClassName = joinClassnames([
    styles.text_input,
    props.icon ? styles.text_input_with_icon : null,
    props.smallPadding ? styles.small_padding : styles.input_padding,
    props.disabled && styles.disabled,
    props.colorType === Type.t1 && styles.text_input_type1,
    props.colorType === Type.t2 && styles.text_input_type2,
    props.colorType === Type.t3 && styles.text_input_type3,
    props.border && styles.border,
    props.shadow && styles.shadow
  ])

  const moveToView = () => {
    if (!inputRef) return
    inputRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }


  return (
    <>
      {props.label && <div className={styles.label}>{(props.required ? "* " : "") + props.label}</div>}

      <div className={styles.container}>
        {props.icon && (
          <div className={styles.icon_wrapper}>
            <FontAwesomeIcon
              className={styles.icon}
              icon={['fas', props.icon]}
            />
          </div>
        )}
        <input
          maximum-scale={1}
          ref={inputRef}
          // onFocus={moveToView}
          disabled={props.disabled}
          value={value}
          type={props.type ?? 'text'}
          placeholder={props.placeholder}
          className={textInputClassName}
          style={{ backgroundColor: props.color }}
          onChange={(e) => {
            if (e.target.value.length < MAX_POST_LENGTH) {
              props.onChange(e.target.value)
              setValue(e.target.value)
            }
          }
          }
        />
      </div>
    </>
  )
}

export default TextInputComponent
